// removed by extract-text-webpack-plugin
module.exports = {"oy_dropdown_input_range":"oy_dropdown_input_range__2MyuWlU-","active":"active__axoen3ci","dropdown":"dropdown__36CTL8X5","icon":"icon__1tuahple","name":"name__1sANpeob","dropdownOffset":"dropdownOffset__2Cp8eID5","input":"input__3q0UGLGA","operation":"operation__2-YJxLYM","btn":"btn__mPa2lphB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYDropdownInputRange/index.module.less
// module id = 739
// module chunks = 1